import { ConfigCasillaDteRecibido } from "./ConfigCasillaDteRecibido";
import { DatosCasilla } from "./DatosCasilla";
import { TipoProveedorCorreo } from "./TipoProveedorCorreo";

export class CasillaDteRecibido {
   public casillaDteRecibidoId: string;
   public emisorId: string;
   public correo: string;
   public host: string;
   public puerto: number;
   public ssl: boolean;
   public password: string;
   public tipoProveedorCorreoId: string;
   public tipoProveedorCorreoEnum: number;
   public fechaCreacion: Date;
   public usuarioId: string;
   public activo: boolean;
   public tipoProveedorCorreo: TipoProveedorCorreo;
   public datosCasilla: DatosCasilla;
   public configCasillaDteRecibido: ConfigCasillaDteRecibido;
   public ConfigBase64: string;
   public clientId: string;
   public tenantId: string;
   public clientSecret: string;
}
